import {
  CtaBuilderFn,
  InstantAnswerContext,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import {
  GoToAccountSettingsCTA,
  GoToOrderFulfillmentCTA,
  SubmitVerificationInformationCTA,
} from "./ctas";

export const CONTACT_US_IF_FURTHER_HELP = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Please contact us if you need any further help.",
    description: {
      img: "https://cdn.faire.com/fastly/09b3a7498df617e8058582e8602a700f0bd7a001e4489210e0d73edcf4ba9aad.png",
    },
  });

export const getAccountSettingsCTA: CtaBuilderFn = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
) => GoToAccountSettingsCTA(strictLocalize);

export const getOrderFulfillmentCTA: CtaBuilderFn = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
) => {
  const brandOrderToken = context.brandOrder?.brand_order?.token;
  if (!brandOrderToken) {
    return undefined;
  }

  return GoToOrderFulfillmentCTA(brandOrderToken, strictLocalize);
};

export const getSubmitVerificationInformationCTA: CtaBuilderFn = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
) => {
  if (!context.brandIdvToken) {
    return undefined;
  }

  return SubmitVerificationInformationCTA(
    context.brandIdvToken,
    strictLocalize
  );
};
